import React, { useEffect, useState } from 'react'
import Page from '../../../../component/Page'
import { getBranchList, getDepartmentsList, getMaterialsTransfersDetail, updateMaterialsTransfers } from '../../services/api'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import TitlePage from '../../../../component/TitlePage'
import { Box, Button, FormControl, MenuItem, Select, TextField, Typography } from '@mui/material'
import PintButton from '../../../../component/PintButton'
import dayjs from 'dayjs'
import DatePicker from '../../../../component/DatePicker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import ConfirmDialog from '../component/ConfirmDialog'
import ConfirmPrint from '../component/ConfirmPrint'
import api from '../../../../api/api';
import Swal from 'sweetalert2'

export default function MaterialsTransfersDetail() {
    const { id } = useParams()
    const navigate = useNavigate();
    const location = useLocation();
    const [detail, setDetail] = useState()
    const [open, setOpen] = useState(false)
    const [openPint, setOpenPint] = useState(false)
    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const [branchs, setBranchs] = useState([])
    const [departments, setDepartments] = useState([])
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [transfersDate, setTransfersDate] = useState(dayjs(new Date()))
    const [branchNo, setBranchNo] = useState('')
    const [toBranchNo, setToBranchNo] = useState('')
    const [departmentName, setDepartmentName] = useState('')
    const [toDepartmentName, setToDepartmentName] = useState('')
    const [rows, setRows] = useState([])
    const getDetail = async () => {
        const data = await getMaterialsTransfersDetail(id)
        setDetail(data)
        setBranchNo(data.BranchNo.BranchNo)
        setToBranchNo(data.ToBranchNo.BranchNo)
        setDepartmentName(data.DepartmentName)
        setToDepartmentName(data.ToDepartmentName)
        setRows(data.Details)
        setTransfersDate(dayjs(data?.DocumentDate))

    }
    useEffect(() => {

        const getBranch = async () => {
            const data = await getBranchList()
            setBranchs(data)
        }
        const getDepartments = async () => {
            const data = await getDepartmentsList()
            setDepartments(data)
        }
        getBranch()
        getDetail()
        getDepartments()
    }, [id])
    useEffect(() => {
        if (location?.state?.new) {
            setOpenPint(true)
        }
    }, [location?.state?.new])
    const download = async () => {
        setLoadingPDF(true)
        const res = await api.get(`material/transfers/${id}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingPDF(false)
    }
    const handleSubmit = async (index) => {
        const body = {
            DocumentDate: dayjs(transfersDate).format('YYYY-MM-DD'),
            BranchNo: branchNo,
            ToBranchNo: toBranchNo,
            DepartmentName: departmentName,
            ToDepartmentName: toDepartmentName,
            Status: index || "Y",
            Details: rows?.map((item) => ({
                RefNo: item?.RefNo,
                ItemNo: item?.ItemNo?.ItemNo,
                BudgetYear: item?.BudgetYear,
                BudgetType: item?.BudgetType,
                Lot: item?.Lot,
                Qty: item?.Qty.toString().replaceAll(',', ''),
                UnitNo: item?.UnitNo?.UnitNo,
                CostPrice: item?.CostPrice,
                Width: item?.RequireSize ? item?.Width : '',
                Length: item?.RequireSize ? item?.Length : '',
                Thick: item?.RequireSize ? item?.Thick : '',
                Status: item?.Status,
                Remark: item?.Remark

            }))
        }
        const post = async () => {
            setLoadingSubmit(true)
            const res = await updateMaterialsTransfers(body, id)
            if (res) {
                if (index === 'N') {
                    Swal.fire(
                        'ยกเลิกรายการสำเร็จ',
                        '',
                        'success'
                    )
                    getDetail()
                } else {
                    setLoadingSubmit(false)
                    setOpen(false)
                    setOpenPint(true)
                }
            }
        }
        post()
    }
    return (
        <Page>
            <TitlePage title='รายละเอียดการโอนวัสดุ' action={
                <PintButton loading={loadingPDF} download={download} />
            } />
            <Box class="row">
                {id && <Box className="col-lg-4 col-md-12">
                    <Typography className="labelInput">เลขที่เอกสาร</Typography>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <TextField value={id} variant="standard" fullWidth disabled={id ? true : false}
                            InputProps={{
                                disableUnderline: true,
                                readOnly: true
                            }}
                        />
                    </Box>
                </Box>}
                <Box className="col-lg-4 col-md-6">
                    <Typography className="labelInput">วันโอนวัสดุ</Typography>
                    <DatePicker value={transfersDate} onChange={e => setTransfersDate(e)} disabled={id ? true : false} />
                </Box>
            </Box>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <label class="labelInput">จากศูนย์เมล็ดพันธุ์ข้าว</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                            <Select value={branchNo || ''} onChange={e => {
                                setBranchNo(e.target.value)
                            }} disableUnderline
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                {branchs?.map((x) => (
                                    <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="labelInput">ไปศูนย์เมล็ดพันธุ์ข้าว</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                            <Select value={toBranchNo || ''} onChange={e => {
                                setToBranchNo(e.target.value)
                            }} disableUnderline
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                {branchs?.map((x) => (
                                    <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <label class="labelInput">หน่วยงานที่โอน</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                            <Select value={departmentName || ''} onChange={e => {
                                setDepartmentName(e.target.value)
                            }} disableUnderline
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                {departments?.map((x) => (
                                    <MenuItem value={x?.DepartmentName}>{x?.DepartmentName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="labelInput">หน่วยงานที่รับโอน</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                            <Select value={toDepartmentName || ''} onChange={e => {
                                setToDepartmentName(e.target.value)
                            }} disableUnderline
                                MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                            >
                                {departments?.map((x) => (
                                    <MenuItem value={x?.DepartmentName}>{x?.DepartmentName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </div>
            </div>

            {id && <div class="row">
                <div class="col-lg-4 col-md-6">
                    <label class="labelInput">ผู้สร้าง</label><label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/YYYY')} )</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <TextField value={detail?.CreateId} variant="standard" fullWidth disabled={id ? true : false}
                            InputProps={{
                                disableUnderline: true,
                                readOnly: true
                            }}
                        />
                    </Box>
                </div>
                <div class="col-lg-4 col-md-6">
                    <label class="labelInput">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/YYYY')} )</label>
                    <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                        <TextField value={detail?.ModifiedId} variant="standard" fullWidth disabled={id ? true : false}
                            InputProps={{
                                disableUnderline: true,
                                readOnly: true
                            }}
                        />
                    </Box>
                </div>

            </div>}
            <TitlePage title='รายการโอนวัสดุ' action={
                !detail ? <FontAwesomeIcon icon={faPlusCircle} /> : null
            } />
            <div class="receiveDetail row">
                <div class="col-md-12 table-responsive-sm" style={{ height: 'auto' }}>
                    <table class="table table-borderless">
                        <thead>
                            <tr>
                                <th class="text-center" >ที่</th>
                                <th class="text-center">เอกสารที่อ้างถึง</th>
                                <th class="text-center" >รายการ</th>
                                <th class="text-center" >ปีงบประมาณ</th>
                                <th class="text-center" >ประเภทเงิน</th>
                                <th class="text-center" >เลขครุภัณฑ์</th>
                                <th class="text-center" >ปริมาณ</th>
                                <th class="text-center" >หน่วย</th>
                                <th class="text-center" >กว้าง (เมตร) </th>
                                <th class="text-center" >ยาว (เมตร)</th>
                                <th class="text-center" >หนา (มิลลิเมตร)</th>
                                <th class="text-center" >ราคา/หน่วย (บาท)</th>
                                <th class="text-center" >สถานะ</th>
                                <th class="text-center" >หมายเหตุ</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="">
                            {rows?.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{i + 1} .</td>
                                        <td>
                                            <TextField
                                                value={item?.RefNo || ''}
                                                onChange={e => {
                                                    const newItem = rows?.map((v, index) => {
                                                        v.RefNo = i === index ? e.target.value : v?.RefNo;
                                                        return v;

                                                    });
                                                    setRows([...newItem]);
                                                }}
                                                sx={{ background: '#fff', width: '100%' }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.ItemNo?.ItemName || ''}
                                                sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                                                InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.BudgetYear || ''}
                                                sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                                                InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.BudgetType || ''}
                                                sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                                                InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.Lot || ''}
                                                sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                                                InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.Qty?.toLocaleString() || ''}
                                                sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                                                InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                onChange={e => {
                                                    const newItem = rows?.map((v, index) => {
                                                        let newValue = e.target.value.replace(/,/g, "");
                                                        let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                        v.Qty = i === index ? abc : v?.Qty;
                                                        return v;

                                                    });
                                                    setRows([...newItem]);
                                                }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.UnitNo?.UnitName || ''}
                                                sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                                                InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.Width || ''}
                                                sx={{ background: !item?.RequireSize ? '#e9ecef' : '#fff', width: '100%' }}
                                                type='number'
                                                disabled={!item?.RequireSize}
                                                error={item?.RequireSize && !item?.Width}
                                                onChange={e => {
                                                    const newItem = rows?.map((v, index) => {
                                                        v.Width = i === index ? e.target.value : v?.Width;
                                                        return v;

                                                    });
                                                    setRows([...newItem]);
                                                }}
                                                size='small' variant='outlined'
                                            />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.Length || ''}
                                                sx={{ background: !item?.RequireSize ? '#e9ecef' : '#fff', width: '100%' }}
                                                type='number'
                                                disabled={!item?.RequireSize}
                                                error={item?.RequireSize && !item?.Length}
                                                onChange={e => {
                                                    const newItem = rows?.map((v, index) => {
                                                        v.Length = i === index ? e.target.value : v?.Length;
                                                        return v;

                                                    });
                                                    setRows([...newItem]);
                                                }}
                                                size='small' variant='outlined'
                                            />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.Thick || ''}
                                                sx={{ background: !item?.RequireSize ? '#e9ecef' : '#fff', width: '100%' }}
                                                type='number'
                                                disabled={!item?.RequireSize}
                                                error={item?.RequireSize && !item?.Thick}
                                                onChange={e => {
                                                    const newItem = rows?.map((v, index) => {
                                                        v.Thick = i === index ? e.target.value : v?.Thick;
                                                        return v;

                                                    });
                                                    setRows([...newItem]);
                                                }}
                                                size='small' variant='outlined'
                                            />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.CostPrice || ''}
                                                sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                                                InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.Status || ''}
                                                sx={{ background: id ? '#e9ecef' : '#fff', width: '100%' }}
                                                InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                size='small' variant='outlined'
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }} />
                                        </td>
                                        <td>
                                            <TextField
                                                value={item?.Remark || ''}
                                                sx={{ background: '#fff', width: '100%' }}
                                                onChange={e => {
                                                    const newItem = rows?.map((v, index) => {
                                                        v.Remark = i === index ? e.target.value : v?.Remark;
                                                        return v;

                                                    });
                                                    setRows([...newItem]);
                                                }}
                                                size='small' variant='outlined'
                                            />
                                        </td>
                                        <td></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <hr class="chr" />
            <div class="row mt-4">
                <div class="col-12">
                    <Button onClick={() => navigate(location?.state?.new ? -2 : -1)} variant='outlined'
                        startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                        sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                    {detail && detail.Status !== 'N' &&
                        <Button variant='contained' onClick={() => setOpen(true)} sx={{ width: '130px', fontSize: '14px' }}>แก้ไข</Button>}
                    {detail && detail.Status !== 'N' &&
                        detail?.Cancelable ?
                        <Button variant='contained' onClick={() => {
                            Swal.fire({
                                title: 'ยืนยันการยกเลิก',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#4ab866',
                                cancelButtonColor: '#d33',
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    handleSubmit('N')
                                }
                            })
                        }} color='error' type='submit' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }}>ยกเลิก</Button> : null
                    }
                </div>
            </div>
            <ConfirmDialog open={open} setOpen={setOpen} rows={rows} handleSubmit={handleSubmit} loadingSubmit={loadingSubmit} />
            <ConfirmPrint title={'บันทึกรายการโอนวัสดุสำเร็จ'} download={download} open={openPint} setOpen={setOpenPint} loadingPDF={loadingPDF} linkTo='/materials/materials-transfers/add' />

        </Page>
    )
}
